// Aurapro — scripts compartidos de las secciones mt-*
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initMarquesina();
  initGaleria();
  initProducto();
  initCtaFijo();
  initAnchors();
  initTabs();
  initTallaAsistente();
});

function initGaleria() {
  var swipe = document.querySelector('[data-mt-galeria-swipe]');
  if (!swipe) return;
  var slides = Array.prototype.slice.call(swipe.querySelectorAll('[data-mt-galeria-slide]'));
  var dots = Array.prototype.slice.call(document.querySelectorAll('[data-mt-dot]'));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-mt-galeria-boton]'));
  var modal = document.querySelector('[data-mt-zoom-modal]');
  var zoomImg = modal ? modal.querySelector('[data-mt-zoom-img]') : null;
  var cerrarBtn = modal ? modal.querySelector('[data-mt-zoom-cerrar]') : null;
  var ultimoFoco = null;

  function irASlide(i) {
    var slide = slides[i];
    if (!slide || !swipe.scrollTo) return;
    swipe.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    marcarActivo(i);
  }

  function marcarActivo(i) {
    dots.forEach(function (d, idx) {
      d.classList.toggle('mt-activa', idx === i);
      d.setAttribute('aria-selected', idx === i ? 'true' : 'false');
    });
    thumbs.forEach(function (t, idx) { t.classList.toggle('mt-activa', idx === i); });
  }

  dots.forEach(function (dot, i) { dot.addEventListener('click', function () { irASlide(i); }); });
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { irASlide(i); }); });

  var scrollTimeout;
  swipe.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      var idx = Math.round(swipe.scrollLeft / Math.max(swipe.clientWidth, 1));
      marcarActivo(idx);
    }, 100);
  });

  slides.forEach(function (slide) {
    slide.addEventListener('click', function () {
      if (!modal || !zoomImg) return;
      var img = slide.querySelector('img');
      if (!img) return;
      ultimoFoco = document.activeElement;
      zoomImg.src = img.currentSrc || img.src;
      zoomImg.alt = img.alt || '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (cerrarBtn) cerrarBtn.focus();
    });
  });

  function cerrarZoom() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarZoom);
  if (modal) {
    modal.addEventListener('click', function (e) { if (e.target === modal) cerrarZoom(); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) cerrarZoom();
  });

  window.mtIrAGaleriaImagen = function (mediaId) {
    var idx = slides.findIndex(function (s) { return s.getAttribute('data-mt-galeria-imagen') === String(mediaId); });
    if (idx > -1) irASlide(idx);
  };
}

function mtTrack(evento, detalle) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: evento }, detalle || {}));
}

function initAnchors() {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var destino = document.getElementById(id);
    if (!destino) return;
    e.preventDefault();
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (id === 'mt-comprar') {
      destino.classList.add('mt-resaltado');
      setTimeout(function () { destino.classList.remove('mt-resaltado'); }, 1200);
    }
  });
}

function initProducto() {
  var form = document.getElementById('mt-product-form');
  if (!form) return;
  var seccionId = form.closest('[id^="shopify-section-"]');
  seccionId = seccionId ? seccionId.id.replace('shopify-section-', '') : null;
  var textoInicialBoton = form.querySelector('[data-mt-boton-texto]');
  var textos = (window.mtTextosProducto && window.mtTextosProducto[seccionId]) || {
    comprar: textoInicialBoton ? textoInicialBoton.textContent.trim() : 'Confirmar pedido — pagaré al recibirlo',
    agotado: 'Esta combinación no está disponible'
  };
  var errorEl = form.querySelector('[data-mt-error]');

  var variantesEl = form.querySelector('[data-mt-variantes]');
  var variantes = variantesEl ? JSON.parse(variantesEl.textContent) : [];
  var input = form.querySelector('[data-mt-variant-input]');
  var boton = form.querySelector('[data-mt-boton-comprar]');
  var botonTexto = form.querySelector('[data-mt-boton-texto]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioComparadoEl = document.querySelector('[data-mt-precio-comparado]');
  var seleccion = {};

  form.querySelectorAll('[data-mt-opcion-indice]').forEach(function (grupo) {
    var indice = grupo.getAttribute('data-mt-opcion-indice');
    var activo = grupo.querySelector('.mt-prod-pill.mt-activa');
    seleccion[indice] = activo ? activo.getAttribute('data-mt-valor') : null;

    grupo.querySelectorAll('.mt-prod-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        grupo.querySelectorAll('.mt-prod-pill').forEach(function (p) { p.classList.remove('mt-activa'); });
        pill.classList.add('mt-activa');
        seleccion[indice] = pill.getAttribute('data-mt-valor');
        actualizarVariante();
        mtTrack('SelectColor', { valor: seleccion[indice] });
      });
    });
  });

  function actualizarVariante() {
    var valores = Object.keys(seleccion).sort().map(function (k) { return seleccion[k]; });
    var variante = variantes.find(function (v) {
      return v.opciones.length === valores.length && v.opciones.every(function (op, i) { return op === valores[i]; });
    });
    if (!variante) return;
    input.value = variante.id;
    // Notificar el cambio de variante a apps externas (p.ej. Releasit COD Form)
    // y reflejarlo en la URL, para que siempre lean la variante seleccionada.
    try {
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      if (window.history && window.history.replaceState) {
        var mtUrl = new URL(window.location.href);
        mtUrl.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', mtUrl);
      }
    } catch (e) {}
    if (variante.imagenId && window.mtIrAGaleriaImagen) window.mtIrAGaleriaImagen(variante.imagenId);
    if (precioEl) precioEl.textContent = variante.precio;
    if (precioComparadoEl) {
      if (variante.tiene_comparado) { precioComparadoEl.textContent = variante.precio_comparado; precioComparadoEl.style.display = ''; }
      else { precioComparadoEl.style.display = 'none'; }
    }
    if (variante.disponible) {
      boton.removeAttribute('disabled');
      input.removeAttribute('disabled');
      if (botonTexto) botonTexto.textContent = textos.comprar;
    } else {
      boton.setAttribute('disabled', 'disabled');
      input.setAttribute('disabled', 'disabled');
      if (botonTexto) botonTexto.textContent = textos.agotado;
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (boton.hasAttribute('disabled')) return;
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    mtTrack('ClickCODCTA', {});
    var formData = new FormData(form);
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = data.description || 'No se pudo completar el pedido. Recarga la página o contacta con soporte.'; }
          return;
        }
        window.location.href = '/cart';
      })
      .catch(function () {
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'No hemos podido completar el pedido. Recarga la página o contacta con soporte.'; }
      });
  });
}

function initCtaFijo() {
  var barra = document.querySelector('[data-mt-cta-fijo]');
  var modulo = document.getElementById('mt-comprar');
  var releasitSlot = document.getElementById('mt-releasit-slot');
  if (!barra || !modulo) return;

  var pasadoModulo = false;
  var tecladoAbierto = false;

  function refrescar() {
    barra.classList.toggle('mt-visible', pasadoModulo && !tecladoAbierto);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      pasadoModulo = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      refrescar();
    });
  }, { threshold: 0 });
  observer.observe(modulo);

  // Oculta la barra si hay un campo de texto enfocado (evita tapar el teclado
  // móvil cuando el usuario rellena el formulario, p.ej. el de Releasit).
  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('input, textarea, select')) {
      tecladoAbierto = true;
      refrescar();
    }
  });
  document.addEventListener('focusout', function (e) {
    if (e.target.matches && e.target.matches('input, textarea, select')) {
      tecladoAbierto = false;
      refrescar();
    }
  });

  var btn = barra.querySelector('[data-mt-cta-fijo-boton]');
  if (btn) {
    btn.addEventListener('click', function () {
      var pillsSinSeleccion = document.querySelector('.mt-prod-pills') && !document.querySelector('.mt-prod-pill.mt-activa');
      var destino = pillsSinSeleccion ? document.querySelector('.mt-prod-opcion') : (releasitSlot || modulo);
      destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      mtTrack('ScrollToReleasit', { origen: 'cta_fijo' });
    });
  }
}

function initTabs() {
  document.querySelectorAll('[data-mt-tabs]').forEach(function (grupo) {
    var botones = grupo.querySelectorAll('[data-mt-tab-boton]');
    var paneles = grupo.querySelectorAll('[data-mt-tab-panel]');
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var objetivo = btn.getAttribute('data-mt-tab-boton');
        botones.forEach(function (b) {
          var activo = b === btn;
          b.classList.toggle('mt-activa', activo);
          b.setAttribute('aria-selected', activo ? 'true' : 'false');
        });
        paneles.forEach(function (p) {
          p.hidden = p.getAttribute('data-mt-tab-panel') !== objetivo;
        });
      });
    });
  });
}

function initTallaAsistente() {
  var form = document.querySelector('[data-mt-talla-asistente]');
  if (!form) return;
  // Reservado: solo se activa si el producto tiene variantes reales de talla.
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: si por lo que sea el navegador no dispara el observer
  // a tiempo (pestaña en segundo plano, casos límite de algunos navegadores),
  // el contenido nunca debe quedar invisible.
  setTimeout(function () {
    document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      el.classList.add('mt-visible');
    });
  }, 2500);
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-pregunta');
    var respuesta = item.querySelector('.mt-faq-respuesta');
    if (!btn || !respuesta) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      items.forEach(function (otro) {
        otro.classList.remove('mt-abierto');
        var r = otro.querySelector('.mt-faq-respuesta');
        var b = otro.querySelector('.mt-faq-pregunta');
        if (r) r.style.maxHeight = null;
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!abierto) {
        item.classList.add('mt-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initMarquesina() {
  var tracks = document.querySelectorAll('.mt-marquesina-track');
  tracks.forEach(function (track) {
    var velocidad = track.getAttribute('data-velocidad') || 30;
    track.style.animationDuration = velocidad + 's';
    if (track.children.length && !track.dataset.duplicado) {
      track.innerHTML += track.innerHTML;
      track.dataset.duplicado = 'true';
    }
  });
}
